// extracted by mini-css-extract-plugin
export var childrenContainer = "_ap-0";
export var virtualScrollArea = "_ap-1";